// Fija la hora a las 12:00 locales para que al serializar a UTC la fecha no cambie de día
export const toNoon = (d: Date | null): Date | null => {
    if (!d || isNaN(d.getTime())) return d
    const r = new Date(d)
    r.setHours(12, 0, 0, 0)
    return r
}
